/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import { Waypoint } from 'react-waypoint'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { GraphicWeek } from '../graphicweek'
import { GraphicMonth } from '../graphicmonth'
import { GraphicHalfyear } from '../graphichalfyear'
import { GraphicYear } from '../graphicyear'
import { GraphicTenYears } from '../graphictenyears'
import { GraphicLife } from '../graphiclife'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { ArticleTeasers, sortMode } from '@ta-interaktiv/react-article-teasers'

// TODO Set the correct article ID here
const ARTICLE_ID = '16453177'
const ADDITIONAL_SHARES = 488
const isMobile = window.innerWidth < 769

let baseUrl = window.location.hostname.replace('interaktiv.', '')
baseUrl = baseUrl.replace('.ch', '')
baseUrl.replace(new RegExp('.', 'g'), '')

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.isMobile = window.innerWidth < 600
    this.isTablet = window.innerWidth < 1025
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
        <ThemeSwitch />

        {/* TODO Replace the following segment with your project cover */}
        <header className='ui vertical segment'>
          <div className='ui container'>
            <h1 className='ui header'>
              So viel Plastik gelangt in unseren Körper
            </h1>

            <h2 className='ui header'>
              <div className='small sub header'>
                Mikroplastik landet überall – auch in unserem Essen. Wir zeigen,
                welche Mengen wir unabsichtlich verzehren und ob das gefährlich
                ist.
              </div>
            </h2>
          </div>
        </header>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'startReading'
              })
            }
          }}
        />

        <div className='content'>
          <div className='ui container'>
              <GraphicWeek />
          </div>
          <div className='ui text container'>
            <p>
              Jeden Tag essen, trinken und atmen wir Plastik. Laut{' '}
              <a href='https://wwf.panda.org/wwf_news/press_releases/?348337/Revealed-plastic-ingestion-by-people-could-be-equating-to-a-credit-card-a-week'>
                Berechnungen der australischen University of Newcastle für den
                WWF
              </a>{' '}
              konsumiert jeder Mensch im weltweiten Durchschnitt pro Woche
              unbewusst 2000 kleine Teilchen davon. Das entspricht etwa 5 Gramm
              – dem Gewicht einer Kreditkarte oder eines Deckels einer
              Plastikflasche. Zerschreddert könnte man damit einen Suppenlöffel
              füllen.{' '}
              <a href='https://graphics.reuters.com/'>Reuters Graphics</a> hat
              diese Mengen auf ein Menschenleben hochgerechnet und fotografisch
              visualisiert.
            </p>
            <p>
              Denn Plastik ist nicht biologisch abbaubar. Stattdessen zerfällt
              er durch den Einfluss der Natur in immer kleinere Teilchen und
              landet schliesslich überall: im Meer, im arktischen Eis, in den
              Bergen. Schon in den entlegensten Gebieten haben Forscher
              Mikroplastik entdeckt. Die Teilchen, die kleiner als fünf
              Millimeter sind, werden vom Wasser transportiert und legen auch
              über die Atmosphäre grosse Entfernungen zurück.
            </p>
            <p>
              Meeresbewohner wie auch Insekten und Landtiere nehmen die
              winzigen, nicht löslichen Partikel unbewusst über ihre Nahrung
              auf. Und die Menschen essen dann diese Tiere. Auch über Kosmetika,
              in Plastik verpackte Lebensmittel oder Plastikgeschirr gelangen
              Teilchen in unseren Körper. Trinkwasser, sowohl vom Hahnen als
              auch aus der Flasche, ist gar die grösste Quelle für die
              Plastikaufnahme.
            </p>
          </div>
          <div className='ui container'>
              <GraphicMonth />
          </div>
          <div className='ui text container'>
            <p>
              Pro Monat nehmen wir 21 Gramm Mikroplastik über unsere Nahrung
              auf. Das entspricht dem Gewicht von fünf Spielwürfeln und füllt
              zerkleinert eine halbe Suppenschüssel.
            </p>
          </div>
          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '25ContentRead'
                })
              }
            }}
          />
          <div className='ui container'>
              <GraphicHalfyear />
          </div>
          <div className='ui text container'>
            <p>
              In einem halben Jahr isst und trinkt ein Mensch im Durchschnitt
              125 Gramm Plastik. Damit kann er seine morgendliche Müesli-Schale
              füllen.
            </p>
          </div>
          <div className='ui container'>
            <GraphicYear />
          </div>
          <div className='ui text container'>
            <p>
              Jedes Jahr gelangt über die Nahrung ein ganzer Teller Mikroplastik
              in unseren Körper.
            </p>
          </div>
          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '50ContentRead'
                })
              }
            }}
          />
          <div className='ui container'>
            <GraphicTenYears />
          </div>
          <div className='ui text container'>
            <p>
              Innerhalb von zehn Jahren – man traut seinen Augen kaum – essen
              wir einen ganzen Rettungsring, der 2,5 Kilogramm wiegt.
            </p>
          </div>
          <div className='ui container'>
            <GraphicLife />
          </div>
          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '75ContentRead'
                })
              }
            }}
          />
          <div className='ui text container'>
            <p>
              Im globalen Durchschnitt werden Menschen <nobr>79 Jahre</nobr>{' '}
              alt. Wenn man annimmt, dass sich die Situation mit dem
              Mikroplastik nicht verbessert oder verschlechtert, essen wir in
              dieser Zeit 20 Kilogramm. So viel wiegen zwei grosse Abfallkübel
              aus Kunststoff.
            </p>
            <p>
              Und das ist sogar noch eine konservative Schätzung. Denn die
              weltweite Produktion von Plastik nimmt laufend zu. Im Jahr 2016
              wurden weltweit 396 Millionen Tonnen neue Kunststoffe produziert –
              zweihundert Mal mehr als noch im Jahr 1950. Laut dem WWF gelangt
              ein Drittel davon in die Umwelt. Bis 2030 könnte die
              Plastikproduktion nochmals um 40 Prozent steigen.
            </p>
            <AutofitIFrame
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/aVxQo/4/'
              height={this.isTablet ? (this.isMobile ? '415' : '550') : '550'}
              width='581'
              style={{ paddingTop: '1em', paddingBottom: '1em' }}
            />
          </div>
          <div className='ui text container'>
            <p>
              Aber wie gefährlich ist Mikroplastik für uns eigentlich? Das ist
              umstritten, weil die Langzeitfolgen auf unseren Körper bisher
              nicht untersucht worden sind. Nach allen aktuell verfügbaren
              Informationen gehe von der derzeitigen Mikroplastik-Konzentration
              im Trinkwasser keine Gefahr aus, schreibt die
              Weltgesundheitsorganisation WHO in einem{' '}
              <a href='https://apps.who.int/iris/bitstream/handle/10665/326499/9789241516198-eng.pdf?ua=1'>
                Bericht
              </a>
              . Mechanismen im Körper sorgten dafür, dass auch kleinere Partikel
              vom Körper wieder ausgeschieden würden. Allerdings brauche es noch
              viel mehr Studien, die sich mit den gesundheitlichen Auswirkungen
              beschäftigten.
            </p>
            <p>
              Dieser Meinung ist auch der ETH-Chemiker Bernhard Wehrli.
              «Toxikologisch ist bisher wenig bekannt über die tatsächliche
              Wirkung. Vieles ist Spekulation», sagte er im{' '}
              <a href='https://www.tagesanzeiger.ch/leben/gesellschaft/herr-professor-wie-gefaehrlich-ist-mikroplastik-im-darm/story/15105991'>
                Interview mit uns
              </a>
              . «Ich gehe nicht davon aus, dass Mikroplastik gefährlich für uns
              ist. Es ist resistent gegen Magensäure, löst sich also nicht auf,
              wenn es durch unseren Verdauungstrakt geht.»
            </p>
            <div className='ta quote'>
              <h3 className='ui small header'>
                «Es gibt Anzeichen, dass Mikroplastik den Magen-Darm-Trakt
                schädigen kann.»
              </h3>
              <span className='quoteLabel'>
                Philipp Schwabl, Erstautor der{' '}
                <a href='https://www.umweltbundesamt.at/fileadmin/site/presse/news_2019/190606_BfR%20Verbraucherforum%20Mikroplastik%20LiebmannB.pdf'>
                  Pilotstudie
                </a>{' '}
                über Mikroplastik im menschlichen Verdauungssystem der
                Medizinischen Universität Wien
              </span>
            </div>
            <p>
              Aus Sicht von österreichischen Forschern, die Plastik im Stuhl von
              Probanden fanden, sind ebenfalls weitere Untersuchungen notwendig,
              um potenzielle Gefahren von Mikroplastik für den Menschen
              abzuschätzen. In ihrem{' '}
              <a href='https://www.tagesanzeiger.ch/wissen/medizin-und-psychologie/forscher-finden-plastik-im-stuhl-saemtlicher-probanden/story/11975983'>
                Pilotversuch
              </a>{' '}
              gab es aber «erste Anzeichen, dass Mikroplastik durch die
              Begünstigung von Entzündungsreaktionen oder Aufnahme schädigender
              Begleitstoffe den Magen-Darm-Trakt schädigen kann». Alleine die
              Möglichkeit, dass es giftig sein könnte, müsse zu denken geben,
              sagt Thava Palanisami von der University of Newcastle, die an der
              neusten Studie beteiligt war.
            </p>
            <p>
              In der Schweiz dürfte der Teller Mikroplastik zum Glück nicht so
              voll sein wie in der weltweiten Perspektive. Das
              Materialforschungsinstitut Empa in Dübendorf schätzt, dass
              hierzulande jährlich etwa 5000 Tonnen Plastik oder 630 Gramm pro
              Kopf in die Umwelt gelangt. Davon seien nur etwa 12 Prozent
              Mikroplastik. Die geringere Menge ist im Vergleich zu anderen
              Staaten auf unser gut funktionierendes Abfallsystem ohne wilde
              Deponien zurückzuführen.
            </p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'contentBottom'
              })
            }
          }}
        />

        {/* TODO Add your credits in this component */}
        <Footer
          articleId={ARTICLE_ID}
          additionalShares={ADDITIONAL_SHARES}
          credits={[
            [
              'Quellen',
              '<a href="https://www.newcastle.edu.au/newsroom/featured/plastic-ingestion-by-people-could-be-equating-to-a-credit-card-a-week">University of Newcastle</a>, Australien; <a href="https://wwf.panda.org/wwf_news/press_releases/?348337/Revealed-plastic-ingestion-by-people-could-be-equating-to-a-credit-card-a-week">WWF</a>'
            ],
            [
              'Fotos',
              'Anand Katakam und Simon Scarr, <a href="https://graphics.reuters.com">Reuters Graphics</a>'
            ],
            ['Text', 'Yannick Wiget'],
            ['Umsetzung und Konzeption', 'Mathias Lutz']
          ]}
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
            <ArticleTeasers
              sorting='reverse chronologically by creation date'
              numberOfCards='three'
              articleIds={[15105991, 11975983, 30393826]}
            />
          </div>
        </Footer>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'pageBottom'
              })
            }
          }}
        />
      </div>
    )
  }
}

export default hot('AppComponent')
